import styles from './styles.module.scss';
import type { Component } from './types';

export const Alert: Component = ({
  date,
  text,
}) => (
  <div className={styles.containerRoot}>
    {text}
    {date && (
      <>
        {' since '}
        {(() => {
          const d = new Date(date);
          const month = d.getMonth();
          const year = d.getFullYear();
          const quarter = Math.floor(month / 3) + 1;
          return `Q${quarter} ${year}`;
        })()}
      </>
    )}
    <span>.</span>
  </div>
);
